<div class="listview">
  <div class="listview-header my-2">
    <div class="row">
      <div class="col-2">
        {{ 'work.shift.singular' | baseBusinessKey | translate }} | {{ 'dateTime.date' | translate }}
      </div>
      <div class="col">{{ 'externalEmployees.timeRecordings.begin' | translate }}</div>
      <div class="col">{{ 'end' | translate }}</div>
      <div class="col">{{ 'work.hours' | translate }}</div>
      <div class="col">{{ 'work.pause' | translate }}</div>
      <div class="col">{{ 'work.workingHours' | translate }}</div>
      <div class="col-3">{{ 'state' | translate }}</div>
    </div>
  </div>
  <base-customer-employee-time-recordings-list-item
    *ngFor="let assignmentDate of assignmentDates"
    [assignmentDate]="assignmentDate"
    [assignmentId]="assignment.id"
  ></base-customer-employee-time-recordings-list-item>
  <base-empty-list-row
    *ngIf="assignmentDates.length === 0"
    message="externalEmployees.timeRecordings.emptyList"
    [backgroundSecondary]="true"
    [hideBackgroundImage]="true"
  ></base-empty-list-row>
</div>
